import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import ThemeContextProvider from "./contexts/ThemeContext";
import AuthContextProvider from './contexts/AuthContext';
import ResponsiveContextProvider from './contexts/ResponsiveContext';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <AuthContextProvider>
        <ResponsiveContextProvider>
          {/* <ThemeContextProvider> */}
          <App />
          {/* </ThemeContextProvider> */}
        </ResponsiveContextProvider>
      </AuthContextProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
